import { openSalesIQChat } from '../utils/openSalesIQChat';

const issues = [
  {
    title: 'Sync Issues',
    description: 'Troubleshoot synchronization problems between devices and cloud services.',
    icon: '🔄',
  },
  {
    title: 'Software Upgrade Errors',
    description: 'Resolve installation and upgrade issues when updating to the latest version.',
    icon: '⚙️',
  },
  {
    title: 'Tree Disappearance',
    description: 'Recover missing family tree data and restore your genealogy work.',
    icon: '🌳',
  },
  {
    title: 'Missing Media Files',
    description: 'Locate and restore photos, documents, and other media attachments.',
    icon: '📁',
  },
  {
    title: 'Mobile Version Display Issues',
    description: 'Fix display and functionality problems on mobile and tablet devices.',
    icon: '📱',
  },
  {
    title: 'Family Member Updates Not Reflecting',
    description: 'Ensure changes and updates are properly saved and synchronized.',
    icon: '📋',
  },
];

export default function SupportIssues() {
  return (
    <section className="py-20 bg-[#e8f5e9]" id="support-issues">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2d2520] mb-6">
          Common Issues We Help With
        </h2>
        <div className="section-divider w-24 mx-auto mb-12" />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {issues.map((issue) => (
            <div
              key={issue.title}
              className="bg-white rounded-xl p-6 border border-[#e8e2d8] hover:border-[#22c55e]/40 hover:shadow-md transition-all duration-300"
            >
              <div className="text-3xl mb-4">{issue.icon}</div>
              <h3 className="text-lg font-bold text-[#2d2520] mb-2">{issue.title}</h3>
              <p className="text-[#5a534a] text-sm leading-relaxed">{issue.description}</p>
            </div>
          ))}
        </div>
        <p className="text-center text-[#2d2520] font-medium mt-10 mb-4">Need help? Chat with our support team</p>
        <div className="flex justify-center">
          <button
            type="button"
            onClick={openSalesIQChat}
            className="bg-[#15803d] hover:bg-[#166534] text-white font-semibold py-3 px-10 rounded-lg text-base transition-colors shadow-md"
          >
            Chat Now
          </button>
        </div>
      </div>
    </section>
  );
}
